/**
 * useUbicacionEntrada — extrae la ubicación formateada de una entrada.
 *
 * Normaliza los campos de asiento/plaza para obtener zona, fila y asiento
 * independientemente de la estructura de datos (asiento vs plaza, snake_case vs camelCase).
 *
 * @param {Object} entrada — Objeto entrada con `asiento` y/o `plaza`
 * @returns {{ zona: string, fila: string, asiento: string }}
 */
export function getUbicacion(entrada) {
    const src = entrada?.asiento ?? entrada?.plaza;
    if (!src) return { zona: '—', fila: '—', asiento: '—' };

    return {
        zona: src.region?.nombre ?? src.zona ?? src.region_name ?? src.sector_name ?? '—',
        fila: src.row ?? src.fila ?? '—',
        asiento: src.seat ?? src.asiento ?? src.butaca ?? src.numero ?? '—',
    };
}
